import { render, staticRenderFns } from "./MainLedgerIndex.vue?vue&type=template&id=e730da2a&scoped=true"
import script from "./MainLedgerIndex.vue?vue&type=script&lang=js"
export * from "./MainLedgerIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e730da2a",
  null
  
)

export default component.exports